// Single source of truth for business details.
// Replace the placeholder values below once and they update across the entire website.

export const CONTACT = {
  email: 'careerwithraaj@gmail.com',
  phone: '+91 98411 40844',
  calendarLink: 'https://calendly.com/careerwithraaj/30min',
};

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/careerwithraaj/',
  youtube: '', // [YOUTUBE LINK]
  linkedin: '', // [LINKEDIN LINK]
  whatsapp: 'https://wa.me/919841140844',
};

export const PLAN_LINKS = {
  clarity: { price: '₹499', paymentLink: 'https://rzp.io/rzp/Z4JIFkuH' }, // Career Clarity Session
  roadmap: { price: '₹1,499', paymentLink: 'https://rzp.io/rzp/XV5bQVr' }, // Career Roadmap
  premium: { price: '₹4,999', paymentLink: 'https://rzp.io/rzp/O02cWJEb' }, // Premium Career Guidance
};

export const PAYMENT_PAGE = 'https://razorpay.me/@careerwithraaj';
